import { Button, Field, Input, ModalDrawer, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { formatInputToCurrency } from '@egw/utils'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditAnnualIncome: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()
  const [defaultAnnualIncomeField, setDefaultAnnualIncomeField] = useState<string | undefined>(undefined)

  const {
    control,
    setValue,
    watch,
    formState: { errors: formErrors },
  } = useFormContext()

  const annualIncome = watch('income')

  useEffect(() => {
    if (annualIncome !== undefined && !defaultAnnualIncomeField) {
      setDefaultAnnualIncomeField(annualIncome)
    }
  }, [annualIncome])

  // Closes the modal and reverts the value to the default value
  // Only using the closeModal method will persist the value
  const closeWithoutSaving = () => {
    setValue('income', defaultAnnualIncomeField)
    closeModal()
  }

  // Sets the new default value for future edits
  const closeWithSaving = () => {
    setDefaultAnnualIncomeField(annualIncome)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.annual_income_title')}
        rightValue={annualIncome}
        testId={'editIsBrokerDealer'}
        onEdit={openModal}
        isPII
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_annual_income')}>
        <>
          <p className="typo-primary-base-semibold text-text-header mb-sm">{t('annual_income.title')}</p>
          <p className="typo-primary-base-regular text-text-meta mb-sm">{t('annual_income.annual_income_p1')}</p>
          <p className="typo-primary-base-regular text-text-meta mb-sm">{t('annual_income.annual_income_p2')}</p>
          <p className="typo-primary-base-regular text-text-meta mb-xl">{t('annual_income.annual_income_p3')}</p>

          <Controller
            name="income"
            control={control}
            rules={{
              required: t('common.required_field'),
            }}
            render={({ field }) => (
              <Input
                {...field}
                onChange={(e) => {
                  const { value } = e.target
                  let formattedValue =
                    formatInputToCurrency(value, true) === '0' ? '' : formatInputToCurrency(value, true) // format to currency
                  formattedValue = formattedValue.replaceAll('.', '') // remove cents
                  e.target.value = formattedValue // set internal value
                  field.onChange(e)
                  setValue('income', formattedValue)
                }}
                label={t('multi.finances.annual_income')}
                testId="annual-income-input"
                error={formErrors.income?.message as string}
                maxLength={12}
                isPII
              />
            )}
          />
          <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
            {t('common.confirm')}
          </Button>
        </>
      </ModalDrawer>
    </>
  )
}
